export enum UpsShipmentStatus {
    /** Being built; not yet sent to UPS (no label/tracking yet). */
    Draft = 'Draft',
    /** Submitted to UPS — has a tracking number and a printed label, not yet picked up. */
    Processed = 'Processed',
    /** At least one package picked up / moving, and not all delivered yet. Set by the tracking job. */
    InTransit = 'In Transit',
    /** Every package delivered. Set by the tracking job. */
    Delivered = 'Delivered',
    /** Cancelled/voided after processing. */
    Voided = 'Voided',
}

/**
 * Per-package progress, set by the tracking job from the UPS Tracking API. A shipment can hold
 * packages at different statuses; the shipment-wide UpsShipmentStatus is derived from these.
 * Exception is one of these statuses (matching UPS's status type 'X') — mutually exclusive with the
 * rest — and the shipment's exception indicator is derived from it via shipmentHasException().
 */
export enum UpsPackageStatus {
    /** Label created / billing info received at UPS — not yet picked up. */
    LabelCreated = 'Label Created',
    /** Picked up and moving (includes out-for-delivery). */
    InTransit = 'In Transit',
    /** A UPS exception (address issue, weather delay, failed attempt, etc.). Mutually exclusive with
     *  the other statuses — matches UPS's own status type 'X'. The reason is in exceptionDetail. */
    Exception = 'Exception',
    /** Delivered. */
    Delivered = 'Delivered',
    /** Returned to sender. */
    Returned = 'Returned',
    /** The shipment was voided — this package's label is cancelled. Set when the shipment is voided. */
    Voided = 'Voided',
}
